import Vue from 'vue'
import i18n from '@/plugins/i18n'
import http from '@/services/http'
import { Translation } from 'shared'

const translation = new Translation(i18n, http, function (language) {
  return require(`@/translations/${language}.json`)
})

Vue.prototype.$translationRoute = translation.route.bind(translation)

export default translation
